var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.activeText") } },
    [
      _c("el-input", {
        model: {
          value: _vm.optionModel.activeText,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "activeText", $$v)
          },
          expression: "optionModel.activeText",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }